import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Navigation from '../components/Navigation';
import Hero from '../components/Hero';
import Reviews from '../components/Reviews';
import About from '../components/About';
import Contact from '../components/Contact';
import '../i18n/i18n'; // Ensure i18n is initialized
import { getProductsByCategory } from '../data/products';
import ImagePageFlipCatalog from '../components/ImagePageFlipCatalog';
import Footer from '../components/Footer';
import FAQ from '../components/FAQ';


const Index = () => {
  const { t, i18n } = useTranslation();
  const [activeSection, setActiveSection] = useState('hero');
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleNavigation = (section) => {
    const element = document.getElementById(section);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };


  const handleProductSelection = (productId) => {
    console.log("Product selected from TurnJS catalog:", productId);
    setSelectedProduct(productId);
  };

  // Update document direction based on language
  useEffect(() => {
    const direction = i18n.language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.dir = direction;
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  // Intersection Observer for active section detection
  useEffect(() => {
    const sections = ['hero', 'catalog', 'about', 'reviews', 'contact'];
    const observers = [];

    sections.forEach((section) => {
      const element = document.getElementById(section);
      if (element) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio > 0.3) {
                setActiveSection(section);
              }
            });
          },
          { threshold: 0.3, rootMargin: '-80px 0px -80px 0px' }
        );
        observer.observe(element);
        observers.push(observer);
      }
    });

    return () => {
      observers.forEach((observer) => observer.disconnect());
    };
  }, []);

  return (
    <div className="min-h-screen w-full max-w-full overflow-x-hidden">
      <Navigation activeSection={activeSection} onNavigate={handleNavigation} />

      <main className="w-full max-w-full overflow-x-hidden">
        <Hero onNavigate={handleNavigation} />
        <ImagePageFlipCatalog />
        <About />
        <Reviews />
        <FAQ />
        <Contact />
      </main>
      <Footer />

    </div>
  );
};

export default Index;